import React, { useState, useEffect, useContext } from "react";
import TextField from "@mui/material/TextField";
import Button from '@mui/material/Button';
import { Grid, Typography, Paper } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Box from "@mui/material/Box";
import successIcon from '../assets/payment-success-icon.png';
import logo from '../assets/images/cards/Chinmaya-Mission-Logo.gif';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';
import { fetchBalaviharReportTypes, runReport } from '../api/reportServices';
import { DataContext } from '../App';
import { Chip, Stack } from '@mui/material';
import { ButtonGroup } from '@mui/material';
import { Table, TableHead, TableRow, TableCell, TableBody, TableContainer } from '@mui/material';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";




export default function Reports() {
    const { accessToken, signOut } = useAuth();
    const { memberProfile, setMemberProfile } = useMember();
    const { eventTypes, setEventTypes } = useMember ();
    const navigate = useNavigate();
    const reportsMenu = memberProfile.menus.find(menu => menu.text === 'Reports');
    const reportTypes = reportsMenu && Array.isArray(reportsMenu.children)
        ? reportsMenu.children.map(child => child.text)
        : [];
    const [bVReportTypes, setBVReportTypes] = useState([]);

        
    const [reportData, setReportData] = useState({
            reportId: "",
            params: {}
        });
    const [reportResult, setReportResult] = useState([]);
    const [success, setSuccess] = useState(false);

    console.log("Report Types :", reportTypes, bVReportTypes, reportData);

    const [selectedReportType, setSelectedReportType] = useState('');
    const [selectedCondition, setSelectedCondition] = useState('');
    const selectedTypeObj = bVReportTypes.find(type => type.name === selectedReportType);
    const reportconditions = selectedTypeObj ? selectedTypeObj.reportconditions : [];
    const [eventData, setEventData] = useState({
        reportId : 0,
        params : {            
        }
    });
    const [rptsessionGrade, setRptSessionGrade] = useState({});
    const [selectedValues, setSelectedValues] = useState({});
    const [selectedType, setSelectedType] = useState(''); // Track selected report type
    const [reportParam, setReportParam] = useState(''); // Default report parameter

useEffect(() => {

    console.log("Token exists or not :", accessToken);

    if (accessToken) {
        if (reportParam) {
        fetchBVReportTypes(); // Fetch Balavihar report types
        }
    } else {
        signOut();
        navigate('/');
    }
    }, [accessToken, reportParam])  // 
const [reportConditions, setReportConditions] = useState([]);


// When selectedTypeObj changes (e.g., after selecting a report type):
useEffect(() => {

  if (selectedTypeObj) {
    setReportConditions(selectedTypeObj.reportConditions || []); // Set report conditions from selected type object
    setSelectedValues({}); // Reset selected values when report type changes

    setReportData({
      reportId: selectedTypeObj.reportId, // or selectedTypeObj.id
      params: {},
       });
    
  } else {
    setReportConditions([]);
    setReportData({
      reportId: '',
      params: {},
    });
  }
    //console.log("Selected Type Object 2:", selectedTypeObj, "Report Conditions :", reportConditions);
}, [selectedTypeObj]);
    console.log("Selected Type Object 2:", success, selectedTypeObj, "Report Conditions :", reportConditions);

const reportTypeChange = (type) => {
    console.log("Report Type change handler called with value:", type);
    //const type = e.target.value;
    setSelectedType(type);

    if (type === 'Balavihar') {
        setReportParam('bv'); // Set report parameter for Balavihar
    }
    else if (type === 'Event') {
        setReportParam('events'); // Set report parameter for Events
    }
    else if (type === 'BOD') {
        setReportParam('bod'); // Set report parameter for BOD
    }
    else if (type === 'Finance') {
        setReportParam('finance'); // Set report parameter for finance
    }
    setSuccess(false);
    setSelectedValues(''); // Reset selected values
    setSelectedReportType(''); // Reset selected report type
    setSelectedCondition(''); // Reset selected condition
    // Reset report conditions and data

    setReportConditions([]);
        setReportData({
            reportId: '',
            params: {},
        });   
}
    const handleReportChange = (e) => {
        //console.log("Event data in Student handle form :", (studentFields))
        setSelectedReportType(e.target.value);
        setReportConditions([]);
        setReportData({
            reportId: '',
            params: {},
        });

    }
// Handler for dropdown change
const handleDropdownChange = (label, value, reportId) => {
    console.log("Dropdown change handler called with label:", label, "value:", value, reportData);
  const updated = { ...selectedValues, [label]: value };
  setSelectedValues(updated);
  setReportData(reportData => ({
    ...reportData,
    params: updated
  }));
      console.log("Dropdown change handler called with label2:", label, "value:", value, reportData);

};
    const handleLogout = () => {
        signOut();
        navigate('/');
    };
    const fetchBVReportTypes = async () => {
        console.log("Token value E", accessToken);
        let response, data;
        try {
            const { response, data } = await fetchBalaviharReportTypes(accessToken, reportParam);


            if (response.ok) {
                //const data = await response.json();
                //setDataFields(data);
                setBVReportTypes(data);
                console.log("Fetch BV Report types data :", data, response, bVReportTypes);
            }
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Fetch events failed');
                handleLogout(); // Logout user
            }

        } catch (error) {
            console.error("Error fetching event types :", error);
            //signOut();
            //navigate('/');
        }
    };


      
    const checkoutHandler = (e) => {
        e.preventDefault();
        //    console.log("transaction before sent to SQS:", (inputFields));
        fetchReportResults();
    };
  const fetchReportResults = async () => {
    console.log("fetchReportResults", accessToken, reportData, reportParam);
    let response, data;
    try {
      const { response, data } = await runReport(accessToken, reportData, reportParam);


      if (response.ok) {
        //const data = await response.json();
        //setDataFields(data);
        setReportResult(data);
        setSuccess(true);
        console.log("Print report:", data, response);
      }
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Fetch events failed');
        handleLogout(); // Logout user
      }

    } catch (error) {
      console.error("Error fetching event types :", error);
      //signOut();
      //navigate('/');
    }
  }; 

const handleDownload = () => {
    // Example report data
    const dataArray = reportResult.datas;
   const worksheet = XLSX.utils.json_to_sheet(dataArray, {
  header: reportResult.headers
});

    // Convert JSON to worksheet
    //const worksheet = XLSX.utils.json_to_sheet(reportResult);

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Generate buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    // Create Blob and download
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "report.xlsx");
  };
                   

    return (
        <div>
            
                <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" gutterBottom>
                        {'CMDFW Report System'}
                    </Typography>
                </Grid>
            <Grid item xs={12} sm={12}>
                <Paper elevation={3}>
                    <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                        <Grid item>
                            <Box sx={{ width: '100%', minWidth: 300 }}>
                                <Typography variant="body2" align="left" gutterBottom>
                                    <div><b>Use the following buttons to get the reports</b></div>
                                    <div><br /></div>
                                </Typography>
                            </Box>
                        </Grid>
                    </Paper>
                </Paper>
            </Grid>
                                            <div><br /></div>

            <Grid item xs={12} sm={12}>
                <Stack direction="row" spacing={2}>
                    {reportTypes.map((type, idx) => (
                        <Button
                            key={idx}
                            variant={selectedType === type ? 'contained' : 'outlined'}
                            onClick={() => reportTypeChange(type)}
                            sx={{
                                borderRadius: '20px',
                                textTransform: 'none',
                                fontWeight: 500,
                                px: 3,
                                transition: 'background 0.2s, color 0.2s',
                                '&:hover': {
                                    backgroundColor: '#1976d2', // Highlight color
                                    color: '#fff',              // Text color on hover
                                    borderColor: '#1976d2',
                                },
                            }}
                        >
                            {type}
                        </Button>
                    ))}
                </Stack>

            </Grid>
            <div><br /></div>
  
            <form onSubmit={checkoutHandler}>
                {reportParam && (
                    
                <Grid container direction="column" alignItems="center" >
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel id="report-type-label">Report Type</InputLabel>
                        <Select
                            required
                            labelId="report-type-label"
                            value={selectedReportType}
                            label="Report Type"
                            onChange={handleReportChange}
                        >
                            {bVReportTypes.map((type, idx) => (
                                <MenuItem key={idx} value={type.name}>{type.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {reportConditions && reportConditions.length > 0 &&
                    reportConditions.map((condObj, idx) => 
                        (
                    <FormControl fullWidth sx={{ mb: 2 }} key={idx}>
                        <InputLabel id={`dropdown-label-${idx}`}>{condObj.displayText}</InputLabel>
                        <Select
                        required
                        labelId={`dropdown-label-${idx}`}
                        value={selectedValues[condObj.conditionKey] || ''}
                        label={condObj.displayText}
                        onChange={e => handleDropdownChange(condObj.conditionKey, e.target.value)}
                        >
                        {condObj.conditionValues && condObj.conditionValues.length > 0 && 
                        condObj.conditionValues.split(',').map((val, vIdx) => (
                            <MenuItem key={vIdx} value={val.trim()}>{val.trim()}</MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    ))}

                </Grid>
                )}
                <div><br /></div>
                <Grid container direction="row" alignItems="left" spacing={5}>
                    <Grid item>
                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }}>Run Report</Button>
                    </Grid>
                </Grid>
                
                {success && (
                <Grid item xs={12} sm={12} align="center">
                <Grid item sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Button type="submit" onClick={handleDownload} align="left" variant="contained" sx={{ mt: 3, mb: 2 }}>Download Report</Button>
                    </Grid>
                {reportResult && reportResult.datas && reportResult.datas.length > 0 ? (
                
                <TableContainer component={Paper} sx={{ mt: 3 }} >
                    <Table>
                        <TableHead>
                            <TableRow>
                                {reportResult.headers.map((header, idx) => (
                                    <TableCell key={idx} sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                                        {header.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reportResult.datas.map((row, rowIdx) => (
                                <TableRow key={rowIdx}>
                                    {reportResult.headers.map((header, colIdx) => (
                                        <TableCell key={colIdx} sx={{ whiteSpace: 'nowrap' }}>
                                            {row[header]}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer> 
                ) : (
                    <Typography variant="body1" align="left" sx={{ mt: 2 }}>
                        <b>No data available for the selected report.</b>
                    </Typography>
                )}

                </Grid>
                 
                )}                                       
                
                 
            </form>
        </div >
    );
}